<div class="sticky-header">
  @if (sharedConfig.quoteRequest.quotes && sharedConfig.quoteRequest.quotes.length > 1) {
    <quote-comparison-top-vs-view
      [selectedQuoteToCompareOne]="selectedQuoteToCompareOne"
      [selectedQuoteToCompareTwo]="selectedQuoteToCompareTwo"
      (incrementQuoteOne)="compIncrementQuoteOne()"
      (incrementQuoteTwo)="compIncrementQuoteTwo()"
    ></quote-comparison-top-vs-view>
  } @else {
    <div class="content-wrapper" style="display: flex; margin-bottom: auto;">
      <!-- image -->
                      <!-- bell icon - only when madate -->
      <!-- premium amount -->
      <div style="display: flex; align-items: center; justify-content: space-between; width: 100%; padding-left: 26px;" [ngStyle]="{'padding-right.px': !selectedQuoteToCompareOne.mandate_violations_draft ? 26 : 0 }">
        <img src="assets/images/insurer-logos/left-color-logos/{{ selectedQuoteToCompareOne?.insurer_id | lowercase }}-colour.svg" />
        <div class="text-wrapper" style="text-align: right; margin-top: 5px;">
          <p style="margin: 0; font-size: 12px;">Quote number:</p>
          <p style="margin: 0;"><b style="font-size: 14px;">{{ selectedQuoteToCompareOne?.quote_nr }}</b></p>
        </div>
      </div>
      <div style="padding-top: 26px;">
        @if (selectedQuoteToCompareOne.mandate_violations_draft) {
          <ion-icon
            style="width: 32px; height: 32px;"
            class="icon-fill-danger"
            (click)="mandate()"
            src="assets/icon/genetic-icons/mandate.svg"
          ></ion-icon>
        }
      </div>
    </div>
      <p style="margin: 0; padding-bottom: 12px; text-align: center;"><b style="font-size: 16px;">R {{ selectedQuoteToCompareOne?.total_premium | number : '1.0-0' }}</b></p>
  }
</div>
<div class="content-wrapper">
  @if (sharedConfig.quoteRequest.quotes && sharedConfig.quoteRequest.quotes.length > 1) {
    <div class="card-wrapper special-card-padding">
      <ion-grid>
        <ion-row class="grid-row">
          <div class="rating">
            <div class="mandate">
              <ion-icon class="icon-fill-light-grey" *ngIf="!selectedQuoteToCompareOne.mandate_violations_draft" src="assets/icon/genetic-icons/mandate.svg"> </ion-icon>
              <ion-icon
              class="icon-fill-danger"
                (click)="mandate()"
                *ngIf="selectedQuoteToCompareOne.mandate_violations_draft"
                src="assets/icon/genetic-icons/mandate.svg"
              ></ion-icon>
            </div>
            <h1>{{ selectedQuoteToCompareOne.rating_ctrl * 100 | number : '2.0-0' }}</h1>
          </div>
          <div class="heading-wrapper">
            <p><b>Overall rating</b></p>
            <small>Based on your preferences</small>
          </div>
          <div class="rating justify-right">
            <h1>{{ selectedQuoteToCompareTwo.rating_ctrl * 100 | number : '2.0-0' }}</h1>
            <div class="mandate">
              <ion-icon class="icon-fill-light-grey" *ngIf="!selectedQuoteToCompareTwo.mandate_violations_draft" src="assets/icon/genetic-icons/mandate.svg"> </ion-icon>
              <ion-icon
              class="icon-fill-danger"
                (click)="mandate()"
                *ngIf="selectedQuoteToCompareTwo.mandate_violations_draft"
                src="assets/icon/genetic-icons/mandate.svg"
              ></ion-icon>
            </div>
          </div>
        </ion-row>
      </ion-grid>
    </div>
  } @else {
    <div class="card-wrapper" style="padding: 16px 40px;" (click)="downloadQuoteSchedule(selectedQuoteToCompareOne)">
      <ion-grid>
        <ion-row class="download-row">
          <div class="download-spacer"></div>
          <div class="heading-wrapper">
            <p><b>Download schedule</b></p>
            <small>This will download your quote schedule</small>
          </div>
          <div class="download-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-download" viewBox="0 0 16 16">
              <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5"/>
              <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708z"/>
            </svg>
          </div>
        </ion-row>
      </ion-grid>
    </div>
  }
  
  <!-- Essential cover -->
  @if (checkProvider(selectedQuoteToCompareOne.insurer_id!) !== 'premia') {
    <div class="card-wrapper" (click)="navEsssentialCover()">
      <ion-grid>
        <ion-row>
          <div class="heading-wrapper">
            <p><b>Essential cover</b></p>
            <small>The crucial to have cover</small>
          </div>
        </ion-row>
      </ion-grid>
        <div class="ratings-progress-wrapper">
          <quote-rating-indicator
            [selectedQuoteToCompareRatingOne]="selectedQuoteToCompareOne.rating_essential"
            [selectedQuoteToCompareRatingTwo]="selectedQuoteToCompareTwo.rating_essential"
            [selectedQuoteToCompareRecommendedOne]="selectedQuoteToCompareOne.recommended"
            [selectedQuoteToCompareRecommendedTwo]="selectedQuoteToCompareTwo.recommended"
          ></quote-rating-indicator>
        </div>
    </div>
  }
  
  <!-- Convenience cover -->
  @if (checkProvider(selectedQuoteToCompareOne.insurer_id!) !== 'premia') {
    <div class="card-wrapper" (click)="navConvenienceCover()">
      <ion-grid>
        <ion-row>
          <div class="heading-wrapper">
            <p><b>Convenience cover</b></p>
            <small>The nice to have cover</small>
          </div>
        </ion-row>
      </ion-grid>
        <div class="ratings-progress-wrapper">
          <quote-rating-indicator
            [selectedQuoteToCompareRatingOne]="selectedQuoteToCompareOne.rating_convenience"
            [selectedQuoteToCompareRatingTwo]="selectedQuoteToCompareTwo.rating_convenience"
            [selectedQuoteToCompareRecommendedOne]="selectedQuoteToCompareOne.recommended"
            [selectedQuoteToCompareRecommendedTwo]="selectedQuoteToCompareTwo.recommended"
          ></quote-rating-indicator>
        </div>
    </div>
  } 
  <!-- Excess -->
  @if (sharedConfig.quoteRequest.quotes && sharedConfig.quoteRequest.quotes.length > 1) {
    <div class="card-wrapper" (click)="navExcessComparison()">
      <ion-grid>
        <ion-row>
          <div class="heading-wrapper">
            <p><b>Excess</b></p>
            <small>Amount you pay when you claim</small>
          </div>
        </ion-row>
      </ion-grid>
        <div class="ratings-progress-wrapper">
          <quote-rating-indicator
            [selectedQuoteToCompareRatingOne]="selectedQuoteToCompareOne.rating_excess"
            [selectedQuoteToCompareRatingTwo]="selectedQuoteToCompareTwo.rating_excess"
            [selectedQuoteToCompareRecommendedOne]="selectedQuoteToCompareOne.recommended"
            [selectedQuoteToCompareRecommendedTwo]="selectedQuoteToCompareTwo.recommended"
          ></quote-rating-indicator>
        </div>
    </div>
  } @else {
    <div class="card-wrapper" style="padding: 16px 40px;" (click)="navExcessComparison()">
      <ion-grid>
        <ion-row class="download-row">
          <div class="download-spacer"></div>
          <div class="heading-wrapper">
            <p><b>Excess</b></p>
            <small>Amount you pay when you claim</small>
          </div>
          <div class="download-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-box-arrow-in-right" viewBox="0 0 16 16">
              <path fill-rule="evenodd" d="M6 3.5a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5h-8a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 0-1 0v2A1.5 1.5 0 0 0 6.5 14h8a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 14.5 2h-8A1.5 1.5 0 0 0 5 3.5v2a.5.5 0 0 0 1 0z"/>
              <path fill-rule="evenodd" d="M11.854 8.354a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5H1.5a.5.5 0 0 0 0 1h8.793l-2.147 2.146a.5.5 0 0 0 .708.708z"/>
            </svg>
          </div>
        </ion-row>
      </ion-grid>
    </div>
  }
  <!-- Premiums -->
   <div class="card-wrapper" style="padding: 16px 40px;" (click)="navPremium()">
      <ion-grid>
        <ion-row class="download-row">
          <div class="download-spacer"></div>
          <div class="heading-wrapper">
            <p><b>Premium</b></p>
            <small>Amount you pay per month</small>
          </div>
          @if (sharedConfig.quoteRequest.quotes && sharedConfig.quoteRequest.quotes.length === 1) {
            <div class="download-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-box-arrow-in-right" viewBox="0 0 16 16">
                <path fill-rule="evenodd" d="M6 3.5a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5h-8a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 0-1 0v2A1.5 1.5 0 0 0 6.5 14h8a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 14.5 2h-8A1.5 1.5 0 0 0 5 3.5v2a.5.5 0 0 0 1 0z"/>
                <path fill-rule="evenodd" d="M11.854 8.354a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5H1.5a.5.5 0 0 0 0 1h8.793l-2.147 2.146a.5.5 0 0 0 .708.708z"/>
              </svg>
            </div>
          }
        </ion-row>
      </ion-grid>
    </div>

  <!-- Special conditions -->
  <div class="card-wrapper" style="padding: 16px 40px;" (click)="navSpecialConditions()">
    <ion-grid>
      <ion-row class="download-row">
        <div class="download-spacer"></div>
        <div class="heading-wrapper">
          <p><b>Conditions</b></p>
          <small>Things to note</small>
        </div>
        @if (sharedConfig.quoteRequest.quotes && sharedConfig.quoteRequest.quotes.length === 1) {
          <div class="download-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-box-arrow-in-right" viewBox="0 0 16 16">
              <path fill-rule="evenodd" d="M6 3.5a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5h-8a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 0-1 0v2A1.5 1.5 0 0 0 6.5 14h8a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 14.5 2h-8A1.5 1.5 0 0 0 5 3.5v2a.5.5 0 0 0 1 0z"/>
              <path fill-rule="evenodd" d="M11.854 8.354a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5H1.5a.5.5 0 0 0 0 1h8.793l-2.147 2.146a.5.5 0 0 0 .708.708z"/>
            </svg>
          </div>
        }
      </ion-row>
    </ion-grid>
  </div>

  <!-- Optional cover -->
  <div class="card-wrapper" style="padding: 16px 40px;" (click)="navOptionalCover()">
    <ion-grid>
      <ion-row class="download-row">
        <div class="download-spacer"></div>
        <div class="heading-wrapper">
          <p><b>Optional cover</b></p>
          <small>Extra cover that you can choose</small>
        </div>
        @if (sharedConfig.quoteRequest.quotes && sharedConfig.quoteRequest.quotes.length === 1) {
          <div class="download-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-box-arrow-in-right" viewBox="0 0 16 16">
              <path fill-rule="evenodd" d="M6 3.5a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5h-8a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 0-1 0v2A1.5 1.5 0 0 0 6.5 14h8a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 14.5 2h-8A1.5 1.5 0 0 0 5 3.5v2a.5.5 0 0 0 1 0z"/>
              <path fill-rule="evenodd" d="M11.854 8.354a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5H1.5a.5.5 0 0 0 0 1h8.793l-2.147 2.146a.5.5 0 0 0 .708.708z"/>
            </svg>
          </div>
        }
      </ion-row>
    </ion-grid>
  </div>
  <div>
    <ion-button class="secondary-button" (click)="startNewQuoteOnOpenStatus()">Go back and edit quote</ion-button>
  </div>
</div>
<div class="banner-padding" *ngIf="sharedConfig.quoteRequest.status === QuoteRequestStatusType.WaitingOnQuotes"></div>
<div class="banner" *ngIf="sharedConfig.quoteRequest.status === QuoteRequestStatusType.WaitingOnQuotes">
  <div class="banner-inner">
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
      <g fill="none" fill-rule="evenodd">
        <g>
          <g>
            <g>
              <path
                class="icon-fill-light"
                d="M12 3c4.97 0 9 4.03 9 9s-4.03 9-9 9-9-4.03-9-9 4.03-9 9-9z"
                transform="translate(-78 -734) translate(0 726) translate(78 8)"
              />
              <path
                class="icon-fill-endorsement-tick"
                d="M14.964 7.678L16.036 8.322 11.188 16.402 7.137 13.509 7.863 12.491 10.812 14.598z"
                transform="translate(-78 -734) translate(0 726) translate(78 8)"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
    <p>We are busy getting your quotes</p>
  </div>
</div>
<div class="compare-button-row">
  <ion-grid>
    <ion-row>
      <ion-col>
        @if (sharedConfig.quoteRequest.quotes && sharedConfig.quoteRequest.quotes.length > 1) {
          <ion-button
          class="choose-quote-button"
          mode="ios"
          [disabled]="sharedConfig.quoteRequest.status !== QuoteRequestStatusType.WaitingToAccept"
          (click)="selectQuote(selectedQuoteToCompareOne)"
          >Pick me</ion-button
          >
        } @else {
          <ion-button
          class="choose-quote-button"
          mode="ios"
          [disabled]="sharedConfig.quoteRequest.status !== QuoteRequestStatusType.WaitingToAccept"
          (click)="selectQuote(selectedQuoteToCompareOne)"
          >Continue</ion-button>
        }
      </ion-col>
      <ion-col>
        @if (sharedConfig.quoteRequest.quotes && sharedConfig.quoteRequest.quotes.length > 1) {
          <ion-button
          class="choose-quote-button"
          mode="ios"
          [disabled]="sharedConfig.quoteRequest.status !== QuoteRequestStatusType.WaitingToAccept"
          (click)="selectQuote(selectedQuoteToCompareTwo)"
          >Pick me</ion-button
          >
        } @else {
          <ion-button
          class="decline-quote-button"
          mode="ios"
          [disabled]="sharedConfig.quoteRequest.status !== QuoteRequestStatusType.WaitingToAccept"
          (click)="declineQuote()"
          >Decline</ion-button
          >
        }
      </ion-col>
    </ion-row>
  </ion-grid>
</div>

<div class="backdrop" *ngIf="showPopupRejectQuoteReason"></div>
<div class="popup-dates limit-width-on-desktop-float" *ngIf="showPopupRejectQuoteReason">
  <div class="text-center">
    <h2 class="h2-bold">Select a reason</h2>
  </div>
  <div class="dates">
    <div class="date-wrapper" *ngFor="let reason of reasons" (click)="rejectQuoteWithReason(reason, selectedQuoteToCompareOne)">
      {{ reason.description }}
    </div>
  </div>
  <div>
    <ion-button class="secondary-button" (click)="closeRejectPopup()">Cancel</ion-button>
  </div>
</div>

<popup-dialog id="quote.comparison.component" *ngIf="sharedConfig.popupDialogShow"></popup-dialog>
